<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Assign Leads</div>
        <div class="box-mini">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Branch
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="branch" v-model="branch_id" @change="changeBranch2">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-5 text-right hidden">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="xl" :items="items" :fields="fields">
              <template v-slot:cell(name)="data">
<!--              <template slot="name" slot-scope="data">-->
                {{data.item.first_name}} {{data.item.last_name}}
              </template>
              <template v-slot:cell(time)="data">
<!--              <template slot="time" slot-scope="data">-->
                {{parseDate(data.item.created_at)}}
              </template>
              <template v-slot:cell(membership_status)="data">
<!--              <template slot="activity" slot-scope="data">-->
                <div v-if="data.item.member">
                  <b-badge v-if="data.item.member.membership" variant="success">Yes</b-badge>
                 <b-badge v-else variant="danger">NO</b-badge>

                </div>
                <b-badge v-else variant="danger">NO</b-badge>
              </template>
              <template v-slot:cell(actions)="data">
<!--              <template slot="actions" slot-scope="data">-->
                <b-button v-if="getRoleId != '33'" size="sm" @click="showModal('assign', data.item.id)" class="btn-table green mr-1">
                  <i class="far fa-eye"></i> Edit
                </b-button>
                <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteData(data.item.id)" class="btn-table danger mb-5" :disabled="getRoleId === '1' ? true : false">
                  <i class="fas fa-times"></i> Delete
                </b-button>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20 hidden" :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/>
          </div>
        </div>
      </div>
    </div>
    <div class="section-modal">
      <b-modal modal-class="modal-custom-image" hide-footer :ref="'assign'" centered title="Assign Membership Advisor">
        <div class="p-10">
          <form @submit.prevent="validateAssignSales()">
            <div class="mb-10">
              <div class="font-13 mb-5">Branch</div>
              <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              <span class="error">{{ errors.first('branch') }}</span>
            </div>
            <div class="mb-10">
              <div class="font-13 mb-5">Assign Membership Advisor</div>
              <b-form-select v-validate="'required'" name="sales_name" v-model="editData.owner_id" class="form-control">
                <option value="null">Please select</option>
                <option v-for="itemData in itemSales" :key="itemData.id" :value="itemData.id">{{itemData.fullname}}</option>
              </b-form-select>
              <span class="error">{{ errors.first('sales_name') }}</span>
            </div>
            <div class="text-center">
              <button type="submit" class="btn-primary mr-10">Submit</button>
              <a href="javascript:void(0)" @click="hideModal('assign')" class="btn-border-primary">Close</a>
            </div>
          </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'AssignLeads',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      fields: [
        {
          key: 'name',
          label: 'Leads Name',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: true
        },
        {
          key: 'leads_source_type.name',
          label: 'Lead Source',
          sortable: true
        },
        {
          key: 'time',
          label: 'Date',
          sortable: true
        },
        {
          key: 'membership_status',
          label: 'Membership Status',
          sortable: true
        },
        {
          key: 'member.membership_last_buy_name',
          label: 'Membership Name',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: true
        },
      ],
      dateWeek: '',
      leadGetId: '',
      items: [],
      dataBranch: [],
      branch_id: null,
      itemSales: [],
      editData: {
        owner_id: null,
      },
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
    }
  },
  methods: {
    validateAssignSales () {
      this.$validator.validateAll().then(result => {
        if(result) {
          // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          // var data = new FormData()
          // data.append('owner_id', this.editData.owner_id)
          axios.put('crm/v1/leads/' + this.leadGetId, this.editData).then(response => {
            this.hideModal('assign')
            this.fetchData()
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            this.$toast.success('Cant save data', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    showModal (id, leads_id) {
      this.leadGetId = leads_id
      this.$refs[id].show()
    },
    hideModal (id) {
      this.$refs[id].hide()
      // this.addPlanner.pt_planner_activity_id = null
      // this.addPlanner.date = ''
      // this.addPlanner.pt_planner_time_id = ''
      // this.addPlanner.member_id = null
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    statusActivity (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDate (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    changeBranch(event) {
      let url = 'crm/v1/sales?status=active&sorting=fullname&sorting_type=asc&branch_id=' + event
      axios.get(url).then(response => {
        this.itemSales = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch2(event) {
      axios.get('crm/v1/leads/assign_leads?branch_id=' + event).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      axios.get('crm/v1/leads/assign_leads?').then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
